import i18n from "src/app/shared/localization/i18n";
export const INVALID_FIELDS_ERROR_MESSAGE: string = i18n.t('contact.invalidFieldsErrorMessage');
export const URL_TO_CHATS_WITH_FILTER = "/chats/";